import { createContext, useState } from "react";

export const CrudCompanyContext = createContext()

export function CrudCompanyProvider({ children, ..._ }) {
  const [notifyNewAccountsCheckbox, setNotifyNewAccountsCheckbox] = useState(true)

  function setChecked(check) {
    setNotifyNewAccountsCheckbox(check ?? !notifyNewAccountsCheckbox)
  }
  
  return (
    <CrudCompanyContext.Provider
      value={{
        notifyNewAccountsCheckbox,
        setChecked
      }}
    >
      {children}
    </CrudCompanyContext.Provider>
  )
}